import { render, staticRenderFns } from "./folders-and-files.vue?vue&type=template&id=11475132&scoped=true"
import script from "./folders-and-files.vue?vue&type=script&lang=js"
export * from "./folders-and-files.vue?vue&type=script&lang=js"
import style0 from "./folders-and-files.vue?vue&type=style&index=0&id=11475132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11475132",
  null
  
)

export default component.exports